import { render } from "./BookingVersionHistory.vue?vue&type=template&id=1d8f591e&ts=true&lang=pug"
import script from "./BookingVersionHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingVersionHistory.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__